import { render, staticRenderFns } from "./RejectForm.vue?vue&type=template&id=6b3b83f0&scoped=true&"
import script from "./RejectForm.vue?vue&type=script&lang=js&"
export * from "./RejectForm.vue?vue&type=script&lang=js&"
import style0 from "./RejectForm.vue?vue&type=style&index=0&id=6b3b83f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b83f0",
  null
  
)

export default component.exports